import { combineReducers } from 'redux';
import layoutReducer from './layoutReducer';
import coursesReducer from './coursesReducer';
import postsReducer from './postsReducer';


export default combineReducers({
  layout: layoutReducer,
  courses: coursesReducer,
  posts: postsReducer
});



// WEBPACK FOOTER //
// ./src/reducers/index.js